module.exports = __webpack_public_path__ + "img/brights.3c64ae0.svg";